<template>
  <div class="container-fluid">
    <Loading 
      :active.sync="isLoading"
      :can-cancel="false"
    />
    <b-modal id="image-modal" hide-footer hide-header centered 
    >
      <div v-for="(element) in currentLayer.images" :key="element.image_id">
        <img class="pattern-image-summary" 
        :src="imageView(getPatternImage(currentLayer.layer_id,element.image_id))" 
        @click="selectedImage(element.image_id)"/>
      </div>      
    </b-modal>
    <modal name="probability-modal" height="auto" width="50%" styles="
      background: #101010;
      border-radius: 5px;"
      :scrollable="true"
    >
      <div class="modal-header">
        <b-row style="width:100%">
          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
          <button class="btn btn-secondary" type="button" @click="hideProbabilityDialog">
            {{ $t("CANCEL") }}
          </button>
          <button class="btn btn-primary" type="button" @click="onProbabilityModalOk">
            {{ $t("OK") }}
          </button>
        </div>
        </b-row>
      </div>
      <div class="modal-body">
        <div v-for="(element) in this.probabilityEditList" :key="element.image_id" class="probability-modal">
          <b-row>
            <b-col cols="1" align-content="center">
              <img class="pattern-image-summary" 
              :src="imageView(getPatternImage(currentLayer.layer_id,element.image_id))" 
              />
            </b-col>
            <b-col cols="4" align-content="center" align-self="center" class="probability-label">
              <label>{{element.img_name}}</label>
            </b-col>
            <b-col cols="2" align-content="center" align-self="center" class="probability-value">
              <b-form-input v-model="element.parts_probability" rows="1" max-rows="1" 
              no-resize type="number"
              ></b-form-input>
            </b-col>
            <b-col align-content="center" align-self="center">
              <input
                type="range"
                class="probability-range"
                min="0"
                max="100"
                step="1"
                v-model="element.parts_probability"
              />
            </b-col>
          </b-row>
        </div>
      </div>    

    </modal>

    <div class="row">
      <div class="col-12">
        <b-tabs v-model="currentTab" class="editor-tabs">
          <b-tab :title="$t('ELEMENT')" active>
            <div class="editor-area-main row">
              <div class="col-9" v-if="showPattern===true">
                <div class="row">
                  <div class="col-3 pattern-title">
                  {{ $t("PATTERN_SETTING") }}
                  </div>
                </div>
                <div v-for="(element) in editData.patterns" :key="element.pattern_id">
                  <div class="pattern-area col-6">
                    <div class="pattern-label">{{ $t("PATTERN_NAME") }}
                    </div>                        
                    <b-input :placeholder="$t('PATTERN_NAME_1')" class="pattern-input" v-model="element.pattern_name" />
                    <div v-for="(element1) in element.pattern_layers" :key="element1.layer_id">
                      <div class="pattern-label-1 pattern-select-image-area" >
                        {{ $t("PATTERN_LAYER") }}{{editData.layers.filter(d=>d.layer_id===element1.layer_id)[0].layer_name}}
                        <b-button class="pattern-button" @click="showSelectImage(element.pattern_id,element1.layer_id)">
                          {{getButtonLabel(element.pattern_id,element1.layer_id)}} </b-button>
                      </div>
                      <div>
                        <label class="pattern-require-label" v-if="hasPatternImage(element.pattern_id,element1.layer_id) === false">{{ $t("REQUIRED") }}</label>
                        <img v-if="hasPatternImage(element.pattern_id,element1.layer_id) === true" class="pattern-image" :src="imageView(getPatternImage(element1.layer_id,element1.image_id))" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-9" v-if="showPattern===false">
                <div class="row" >
                  <div class="editor-area-1" 
                  >
                    <div class="text-left label-1">
                       {{ $t("ITEM_1") }}{{currentLayerIndex}} {{ $t("ITEM_2") }} ：{{currentLayer.layer_name}}
                    </div>
                    <div class="editor-upload-area" @dragenter="dragEnter" :class="{enter: isEnter}" 
                  @dragleave="dragLeave" @dragover.prevent @drop.prevent="dropFile">
                      <div class="text-center label-1">
                        {{ $t("EXPLANATION_1") }}
                      </div>
                      <div class="text-center label-2">
                        {{ $t("EXPLANATION_2") }}
                      </div>
                      <label for="corporation_file" class="btn editor-upload-label editor-upload-button">
                          {{ $t("EXPLANATION_3") }}
                        <input type="file" style="display:none;" multiple="multiple"
                          id="corporation_file" @change="dropFile"
                        >
                      </label>                      
                    </div>
                    <div class="text-left label-1">
                      {{ $t("ELEMENT_2") }}
                    </div>
                    <div>
                      <div class="swiper-container">
                        <div class="swiper-slide" v-for="(image,index) in currentLayer.images" :key="image.image_id">
                          <small-image v-model="currentLayer.images[index]" ref="smallImage"
                            @click="clickImage" @input="clickImage"
                            >
                          </small-image>  
                        </div>                    
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="control-area">
                    <div class="col-5">
                      <div class="control-select-area">
                        <div class="control-label-1">
                          {{ $t("SELECTED") }}
                        </div>
                        <div class="control-label-2">
                          {{ $t("ITEM_1") }}{{currentLayerIndex}} {{ $t("ITEM_2") }}
                        </div>
                        <div>
                          <b-input class="control-input" v-model="currentLayer.layer_name" />
                        </div>
                        <div class="control-label-2">
                          <label>{{ $t("GENE_RATE") }}</label>
                          <label class="control-label-3">{{currentLayer.layer_probability}}%</label>
                        </div>
                        <div>
                          <input
                            type="range"
                            class="control-range"
                            min="0"
                            max="100"
                            step="1"
                            v-model.number="currentLayer.layer_probability"
                            v-on:mouseup="layerRangeUp"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-7">
                      <div class="control-select-area">
                        <div class="control-label-1">
                          {{ $t("SELECT_ITEM") }}
                          <b-button class="probability-button"  @click="openProbabilityDialog">
                            {{$t("PROBABILITY_SETTING")}}
                          </b-button>
                        </div>
                        <div class="control-label-2">
                          {{ $t("ELEMENT_3") }}
                        </div>
                        <div>
                          <b-input class="control-input" v-model="currentFile.img_name"/>
                        </div>
                        <div class="control-label-2">
                          <label>{{ $t("GENE_RATE") }}</label>
                          <label class="control-label-3">{{currentFile.parts_probability}}%</label>
                        </div>
                        <div>
                          <input
                            type="range"
                            class="control-range"
                            min="0"
                            max="100"
                            step="1"
                            v-model.number="currentFile.parts_probability"
                            v-on:mouseup="fileRangeUp"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <b-tabs class="col-3 setting-tab-title" justified v-model="activeTab" v-on:activate-tab="changeShowPattern">
                <b-tab :title="$t('LAYER_SETTING')"  :active="activeTab === 0">
                <div>
                  <b-button class="layer-add-button" @click="addLayer">{{ $t("ADD_LAYER") }}
                    <b-icon-plus-circle ></b-icon-plus-circle>
                  </b-button>
                </div>
                <div class="layer-summary">
                  <draggable
                    v-model="editData.layers"
                    handle=".handle"
                    animation: 200
                    @end="onDragEnd"
                  >
                    <div v-for="(element,index) in editData.layers" :key="element.layer_id">
                      <LayerItem v-model="editData.layers[index]" 
                      @click="clickLayer" ref="layerItem"
                      />
                    </div>
                  </draggable>
                </div>
                <div class="row">
                  <div class="col-6">
                <div class="control-label-2">
                  {{ $t("GENE_NUMBER") }}
                </div>
                <div class="image-cancreate">
                  <label class="image-cancreate-label">{{editData.number_of_images}}</label>
                  <span class="control-label-2">{{ $t("SHEETS") }}</span>
                </div>
                  </div>
                  <div class="col-6">
                    <!-- <b-button class="preview-buttn">プレビュー</b-button> -->
                  </div>
                </div>
                </b-tab>
                <b-tab :title="$t('PATTERN_SETTING_2')" :active="activeTab === 1">
                  <div>
                    <b-button class="layer-add-button" @click="addPattern">{{ $t("ADD_PATTERN" ) }}
                      <b-icon-plus-circle ></b-icon-plus-circle>
                    </b-button>
                    <div v-for="(element) in editData.patterns" :key="element.pattern_id">
                      <li
                        class="list-group-item d-flex justify-content-between align-items-start"
                      >
                        <b-input class="pattern-summary-name" v-model="element.pattern_name"  readonly="readonly">
                        </b-input>
                        <span>
                            <b-icon-x-circle
                            class="delete-button"
                            aria-hidden="true"
                            @click="deletePattern(element.pattern_id)"
                          ></b-icon-x-circle>
                        </span>
                      </li>

                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </b-tab>
          <b-tab :title="$t('PROJECT')" class="project-summary-area">
            <div class="row">
              <div class="col-3">
                <div class="text-left label-1">{{ $t("PROJECT_NAME" ) }}</div>
                <b-form-input id="project-name" v-model="editData.project_name">{{editData.project_name}}</b-form-input>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="text-left label-1">{{ $t("PROJECT_OVER") }}</div>
                <b-form-textarea id="project-summary" rows="10" v-model="editData.project_theme">{{editData.project_theme}}</b-form-textarea>
              </div>
            </div>
          </b-tab>
          <b-tab :title="$t('PREVIEW')"  class="project-summary-area">
            <Preview 
              :projectName="editData.project_name"
              :projectId="editData.project_id"
              :currentTab="currentTab"
              :user_id="editData.user_id"
              :paymentLevel="paymentLevel"
              @setPaymentLevel="setPaymentLevel"
              @changeTabs="changeTabs"
              ref="preview"
            />
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-link href="https://www.vestone.co.jp/press/privacy/index.html" class="text-secondary">{{ $t("POLICY") }} </b-link>
      </div>
    </div>
    <div class="row">
      <div class="col-9">
      </div>
      <div class="col-3">
        <div class="btn-group btn-group-sm contact-support-group" role="group">
          <b-button type="button" class="btn btn-primary contact-button" @click="openQA">
            <b-icon-chat-square-dots></b-icon-chat-square-dots>
              {{ $t("CONTACT") }}</b-button>
            <b-button type="button" onclick="location.href='https://nft-guide.jp/2021/12/10/post-2274/'" class="btn btn-primary support-button">
            <b-icon-question-circle></b-icon-question-circle>
              {{ $t("SUPPORT") }}</b-button>
        </div>                  
      </div>
    </div>
    <div class="bl_head_btns">
    <b-icon-person-circle class="payment-level-icon"></b-icon-person-circle><label class="payment-level-label">{{paymentName}}</label>
    <b-button class="save-button" @click="saveData">{{ $t("SAVE") }}</b-button>
    <!-- <b-button class="opensea-upload-button">Openseaにアップロード</b-button> -->
    </div>
    <!-- </b-card> -->
  </div>
</template>
<script>
import draggable from "vuedraggable";
import LayerItem from "./LayerItem.vue";
import Preview from "./Preview.vue";
import axios from "axios";
import Const from "../common/Const";
import SmallImage from "./SmallImage";
import { v4 as uuidv4 } from "uuid";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { i18n } from "../lang";

export default {
  components: {
    draggable,
    LayerItem,
    SmallImage,
    Preview,
    Loading,
  },
  name: "Editor",
  data() {
    return {
      swiperOption: {
        slidesPerView: 7,
        spaceBetween: 10,
        slidesPerGroup: 7,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      layerRange: 0,
      fileRange: 0,
      editData: {},
      currentFile: {},
      currentLayer: {},
      isEnter: false,
      files: [],
      layers: [],
      images: [],
      number_of_images: 0,
      layerLabel: "",
      isLoading: false,
      fullPage: true,
      oldImageProbability: 0,
      showPattern: false,
      currentPattern: {},
      selectImageModal: "",
      activeTab: 0,
      currentLayerIndex: "",
      paymentShow: false,
      currentTab: 0,
      paymentLevel: Const.PAYMENT_LEVEL.FREE,
      paymentName: Const.PAYMENT_NAME.FREE,
      intervalId: undefined,
      saveStartTime: null,
      probabilityEditList: [],
    };
  },
  mounted() {
    this.isLoading = true;
    let self = this;
    //console.log("SUCCESS:" + this.$route.query.success);
    axios
      .get(`${Const.API_URL_BASE}/users/${self.$cognito.getUserId()}`, {
        headers: { Authorization: self.$cognito.getToken() },
      })
      .then(function (res) {
        self.editData = res.data;
        axios
          .get(
            `${Const.API_URL_BASE}/generate_images/possible_number/${self.editData.project_id}`,
            {
              headers: { Authorization: self.$cognito.getToken() },
            }
          )
          .then(function (res1) {
            self.editData.number_of_images = res1.data.number_of_images;
            if (res.data.layers.length > 0) {
              self.currentLayer = res.data.layers[0];
              self.$refs.layerItem[0].setLayerActive(true);
              self.currentLayerIndex = 1;
            }
            self.imageDownload();
            self.$refs.preview.getPaymentLevel(self.editData.user_id);
            self.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            self.$bvModal
              .msgBoxOk(i18n.t("FAILED"))
              .then((value) => {})
              .catch((err) => {
                console.log(err);
              });
            self.isLoading = false;
          });
      })
      .catch(function (error) {
        console.log(error);
        self.$bvModal
          .msgBoxOk(i18n.t("FAILED"))
          .then((value) => {})
          .catch((err) => {
            console.log(err);
          });
        self.isLoading = false;
      });
  },
  methods: {
    onProbabilityModalOk() {
      let sum = this.probabilityEditList.reduce(
        (s, e) => parseFloat(s) + parseFloat(e.parts_probability),
        0
      );
      for (let i = 0; i < this.currentLayer.images.length; i++) {
        this.currentLayer.images[i].parts_probability =
          (this.probabilityEditList[i].parts_probability / sum) * 100;
      }
      this.$modal.hide("probability-modal");
    },
    hideProbabilityDialog() {
      this.$modal.hide("probability-modal");
    },
    openProbabilityDialog() {
      this.probabilityEditList = JSON.parse(
        JSON.stringify(this.currentLayer.images)
      );
      this.$modal.show("probability-modal");
    },
    setPaymentLevel(aLevel) {
      this.paymentLevel = aLevel;
      switch (aLevel) {
        case 0:
          this.paymentName = Const.PAYMENT_NAME.FREE;
          break;
        case 10:
          this.paymentName = Const.PAYMENT_NAME.S;
          break;
        case 20:
          this.paymentName = Const.PAYMENT_NAME.M;
          break;
        case 30:
          this.paymentName = Const.PAYMENT_NAME.L;
          break;
        case 99:
          this.paymentName = Const.PAYMENT_NAME.PRE;
          break;
        default:
          this.paymentName = Const.PAYMENT_NAME.NONE;
      }
    },
    imageDownload() {
      let self = this;
      for (let i = 0; i < this.editData.layers.length; i++) {
        for (let j = 0; j < this.editData.layers[i].images.length; j++) {
          axios({
            url: self.editData.layers[i].images[j].image,
            method: "GET",
            responseType: "arraybuffer",
          })
            .then((response) => {
              let bstr = new Buffer(response.data, "binary").toString("base64");
              self.editData.layers[i].images[j].image = bstr;
            })
            .catch(function (error) {
              throw error;
            });
        }
      }
    },
    changeTabs(num) {
      this.currentTab = num;
    },
    getButtonLabel(aPattern, aLayer) {
      let imgid = this.editData.patterns
        .filter((d) => d.pattern_id === aPattern)[0]
        .pattern_layers.filter((d) => d.layer_id === aLayer)[0].image_id;
      if (imgid === "") {
        return i18n.t("ELE_SELECT");
      } else {
        return this.editData.layers
          .filter((d) => d.layer_id === aLayer)[0]
          .images.filter((d) => d.image_id === imgid)[0].img_name;
      }
    },
    onDragEnd(e) {
      this.getCurrentIndex();
    },
    getCurrentIndex() {
      for (let i = 0; i < this.editData.layers.length; i++) {
        if (this.editData.layers[i].layer_id === this.currentLayer.layer_id) {
          this.currentLayerIndex = i + 1;
          return;
        }
      }
    },
    hasImage(aLayer) {
      if (this.editData.layers.length > 0) {
        if (
          this.editData.layers.filter((d) => d.layer_id === aLayer)[0].images
            .length > 0
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        false;
      }
    },
    hasPatternImage(aPattern, aLayer) {
      if (
        this.editData.patterns
          .filter((d) => d.pattern_id === aPattern)[0]
          .pattern_layers.filter((d) => d.layer_id === aLayer)[0].image_id ===
        ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    selectedImage(aImageId) {
      this.currentPattern.pattern_layers.filter(
        (d) => d.layer_id === this.currentLayer.layer_id
      )[0].image_id = aImageId;
      this.$bvModal.hide("image-modal");
    },
    showSelectImage(aPattern, aLayer) {
      if (
        this.editData.layers.filter((d) => d.layer_id === aLayer)[0].images
          .length === 0
      ) {
        this.activeTab = 0;
      } else {
        this.currentLayer = this.editData.layers.filter(
          (d) => d.layer_id === aLayer
        )[0];
        this.currentPattern = this.editData.patterns.filter(
          (d) => d.pattern_id === aPattern
        )[0];
        this.$bvModal.show("image-modal");
      }
    },
    getPatternImage(aLayerId, aImageId) {
      let ret = "";
      if (aImageId === "") {
      } else {
        for (let i = 0; i < this.editData.layers.length; i++) {
          if (this.editData.layers[i].layer_id === aLayerId) {
            for (let j = 0; j < this.editData.layers[i].images.length; j++) {
              if (this.editData.layers[i].images[j].image_id === aImageId) {
                ret = this.editData.layers[i].images[j].image;
                break;
              }
            }
          }
        }
      }
      return ret;
    },
    deletePattern(deleteId) {
      var self = this;
      this.$bvModal
        .msgBoxConfirm(i18n.t("PATTERN_DEL"))
        .then((value) => {
          if (value === true) {
            self.editData.patterns = self.editData.patterns.filter(
              (d) => d.pattern_id != deleteId
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addPattern() {
      let layermap = this.editData.layers.map((d) => {
        return { layer_id: d.layer_id, image_id: "" };
      });
      this.editData.patterns.push({
        pattern_id: uuidv4(),
        pattern_name: "",
        pattern_layers: layermap,
      });
    },
    changeShowPattern(newTabIndex, oldTabIndex, event) {
      if (newTabIndex === 0) {
        for (let i = 0; i < this.editData.layers.length; i++) {
          if (this.editData.layers[i].layer_id === this.currentLayer.layer_id) {
            this.$refs.layerItem[i].setLayerActive(true);
          } else {
            this.$refs.layerItem[i].setLayerActive(false);
          }
        }
        this.showPattern = false;
      } else {
        this.showPattern = true;
      }
    },
    openQA() {
      window.open(
        "http://lp.nft-guide.jp/contact/",
        "_blank",
        "noopener,noreferrer"
      );
    },
    imageView(image) {
      return `data:image/png;base64,${image}`;
    },
    clickPattern(index) {
      this.currentPattern = this.editData.patterns[index];
    },
    clickLayer(e) {
      var self = this;
      if (e.deleteFlag === true) {
        self.editData.layers = self.editData.layers.filter(
          (d) => d.layer_id !== e.layer_id
        );
        for (let i = 0; i < self.editData.patterns.length; i++) {
          self.editData.patterns[i].pattern_layers = self.editData.patterns[
            i
          ].pattern_layers.filter((d) => d.layer_id != e.layer_id);
        }
        self.currentFile = {};
        self.currentLayer = {};
        self.currentLayerIndex = "";
      } else {
        if (this.currentLayer !== e) {
          this.currentFile = {};
        }
        this.currentLayer = e;

        for (let i = 0; i < this.$refs.layerItem.length; i++) {
          this.$refs.layerItem[i].setLayerActive(false);
        }

        for (let i = 0; i < this.$refs.layerItem.length; i++) {
          if (this.$refs.layerItem[i].layer_id === this.currentLayer.layer_id) {
            this.$refs.layerItem[i].setLayerActive(true);
            break;
          }
        }

        this.getCurrentIndex();
      }
    },
    addLayer() {
      let saveLayer = this.currentLayer;
      let order = this.editData.layers.length;
      let id = uuidv4();
      this.editData.layers.push({
        layer_id: id,
        layer_name: "layer name",
        layer_order: order,
        layer_probability: 100,
        images: [],
      });
      this.editData.patterns.forEach((v, i, a) => {
        v.pattern_layers.push({ layer_id: id, image_id: "" });
      });
      this.currentLayer = saveLayer;
    },
    layerRangeUp() {
      for (let i = 0; i < this.editData.layers.length; i++) {
        if (this.currentLayer.layer_id === this.editData.layers[i].layer_id) {
          this.editData.layers[i].layer_probability =
            this.currentLayer.layer_probability;
          break;
        }
      }
    },
    calcFileProbability(probability) {
      if (probability === 100 || this.currentLayer.images.length === 0) {
        return [0, 0];
      }
      if (this.currentLayer.images.length === 1) {
        return [100, 0];
      }
      let fileCount = this.currentLayer.images.length - 1;
      let divide = 100 - probability;
      return [divide / fileCount, divide % (divide / fileCount)];
    },
    calcProbability(oldProbability, newProbability, currentFileArg) {
      let divide = Math.abs(oldProbability - newProbability);
      if (divide === 0) {
        return;
      }
      let otherProbability = 0;
      let execArray = [];
      let curPos = -1;
      let sign = oldProbability - newProbability < 0 ? -1 : 1;
      this.currentLayer.images.forEach((v, i, a) => {
        if (currentFileArg.image_id === v.image_id) {
          v.parts_probability = parseFloat(currentFileArg.parts_probability);
          this.oldImageProbability = parseFloat(
            currentFileArg.parts_probability
          );
          curPos = v.image_id;
        } else {
          otherProbability += parseFloat(v.parts_probability);
          execArray.push(v);
        }
      });
      this.recursProbability(divide, execArray, otherProbability, curPos, sign);
    },
    recursProbability(divide, execArray, otherProbability, curPos, sign) {
      if (divide <= 0 || execArray.length === 0) {
        return;
      }
      let newOther = divide;
      let newExecArray = [];
      this.currentLayer.images.forEach((v, i, a) => {
        if (curPos === v.image_id) {
        } else {
          let n = parseFloat(
            parseFloat(divide) *
              (parseFloat(v.parts_probability) / parseFloat(otherProbability))
          );
          if (n > 0) {
            let m = parseFloat(v.parts_probability) + n * sign;
            if (m < 0) {
              newOther = newOther + (m + v.parts_probability);
              v.parts_probability = 0;
            } else {
              v.parts_probability = m;
              newOther = newOther - n * 10;
              newExecArray.push(v);
            }
          }
        }
      });
      this.recursProbability(
        newOther,
        newExecArray,
        otherProbability,
        curPos,
        sign
      );
    },
    fileProbabilityChanged(oldProbability, newProbability, currentFileArg) {
      this.calcProbability(oldProbability, newProbability, currentFileArg);
    },
    fileRangeUp() {
      this.fileProbabilityChanged(
        this.oldImageProbability,
        this.currentFile.parts_probability,
        this.currentFile
      );
    },
    saveData: function () {
      this.isLoading = true;
      this.saveStartTime = Date.now();
      for (let i = 0; i < this.editData.layers.length; i++) {
        this.editData.layers[i].layer_order = i;
      }
      let self = this;
      axios
        .get(
          `${Const.API_URL_BASE}/store_s3_json/${self.editData.project_id}`,
          {
            headers: { Authorization: self.$cognito.getToken() },
          }
        )
        .then(function (res) {
          axios({
            method: "PUT",
            url: res["data"]["Location"],
            headers: {
              "content-type": "application/json",
            },
            data: JSON.stringify(self.editData),
          });
          self.$refs.preview.getPaymentLevel(self.editData.user_id);
          self.intervalId = setInterval(() => {
            let diff = Math.floor(
              Math.abs(self.saveStartTime - Date.now()) / (60 * 1000)
            );
            if (diff > 30) {
              self.isLoading = false;
              self.saveStartTime = null;
              clearInterval(self.intervalId);
              console.log(error);
              self.$bvModal
                .msgBoxOk(i18n.t("SAVE_FILED"))
                .then((value) => {})
                .catch((err) => {
                  console.log(err);
                });
            } else {
              axios
                .get(
                  `${Const.API_URL_PROCESS_CTRL}/${self.editData.project_id}`,
                  {
                    headers: { Authorization: self.$cognito.getToken() },
                  }
                )
                .then(function (res) {
                  if (res.data.result === "completed") {
                    clearInterval(self.intervalId);
                    self.isLoading = false;
                    self.saveStartTime = null;
                    self.$bvModal
                      .msgBoxOk(i18n.t("SAVE_SUCCESS"))
                      .then((value) => {})
                      .catch((err) => {
                        console.log(err);
                      });
                  }
                })
                .catch(function (error) {
                  self.isLoading = false;
                  self.saveStartTime = null;
                  console.log(error);
                  self.$bvModal
                    .msgBoxOk(i18n.t("SAVE_FILED"))
                    .then((value) => {})
                    .catch((err) => {
                      console.log(err);
                    });
                });
            }
          }, 3000);
        })
        .catch(function (error) {
          self.isLoading = false;
          console.log(error);
          self.saveStartTime = null;
          self.$bvModal
            .msgBoxOk(i18n.t("SAVE_FILED"))
            .then((value) => {})
            .catch((err) => {
              console.log(err);
            });
        });
      let cnt = 0;
      let timerId = setInterval(
        function () {
          axios
            .get(
              `${Const.API_URL_BASE}/generate_images/possible_number/${self.editData.project_id}`,
              {
                headers: { Authorization: self.$cognito.getToken() },
              }
            )
            .then(function (res1) {
              self.editData.number_of_images = res1.data.number_of_images;
            });
          self.$forceUpdate();
          cnt++;
          if (cnt === 6) {
            clearInterval(timerId);
          }
        }.bind(this),
        10000
      );
    },
    clickImage(e) {
      if (e.deleteFlag === true) {
        this.fileProbabilityChanged(e.parts_probability, 0, e);

        this.currentLayer.images = this.currentLayer.images.filter(
          (d) => d.image_id !== e.image_id
        );
        for (let i = 0; i < this.editData.layers.length; i++) {
          if (this.editData.layers[i].layer_id === this.currentLayer.layer_id) {
            this.editData.layers[i].images = this.currentLayer.images;
            break;
          }
        }
        for (let i = 0; i < this.editData.patterns.length; i++) {
          for (
            let j = 0;
            j < this.editData.patterns[i].pattern_layers.length;
            j++
          ) {
            if (
              this.editData.patterns[i].pattern_layers[j].image_id ===
              e.image_id
            ) {
              this.editData.patterns[i].pattern_layers[j].image_id = "";
            }
          }
        }
      } else {
        for (let i = 0; i < this.currentLayer.images.length; i++) {
          if (this.currentLayer.images[i].image_id === e.image_id) {
            this.$refs.smallImage[i].setImageActive(true);
            this.oldImageProbability =
              this.currentLayer.images[i].parts_probability;
          } else {
            this.$refs.smallImage[i].setImageActive(false);
          }
        }
        this.currentFile = e;
      }
    },
    dragEnter() {
      this.isEnter = true;
    },
    dragLeave() {
      this.isEnter = false;
    },
    dragOver() {
      console.log("DragOver");
    },
    dropFile(event) {
      try {
        let self = this;
        this.files = event.target.files
          ? event.target.files
          : event.dataTransfer.files;
        for (let i = 0; i < this.currentLayer.images.length; i++) {
          this.$refs.smallImage[i].setImageActive(false);
        }
        this.currentFile = null;
        for (let i = 0; i < this.editData.layers.length; i++) {
          if (this.editData.layers[i].layer_id === this.currentLayer.layer_id) {
            for (let j = 0; j < this.files.length; j++) {
              let reader = new FileReader();
              reader.onload = () => {
                let e = reader.result;
                self.currentLayer.images.push({
                  image_id: uuidv4(),
                  img_name: this.files[j].name.replace(/^(.+)\..+$/, "$1"),
                  file_name: this.files[j].name,
                  parts_probability: 100,
                  image: e.replace("data:image/png;base64,", ""),
                });
                self.currentFile =
                  self.currentLayer.images[self.currentLayer.images.length - 1];
                self.currentFile.parts_probability =
                  100 / self.currentLayer.images.length;
                self.oldImageProbability = 0;
                self.fileProbabilityChanged(
                  self.oldImageProbability,
                  self.currentFile.parts_probability,
                  self.currentFile
                );
              };
              reader.readAsDataURL(this.files[j]);
            }
          }
        }
        this.isEnter = false;
      } catch (e) {
        if (e instanceof TypeError) {
          this.$bvModal.msgBoxOk(i18n.t("SELECT_LAYER"));
        } else {
          console.error(e);
        }
      }
    },
  },
};
</script>
<style scoped>
.probability-save-button {
  background: #147bfc 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}
.probability-cancel-button {
  background: #147bfc 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.probability-modal {
  background: #101010;
  color: white;
  height: auto;
}
.probability-button {
  background: #147bfc 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  position: absolute;
  right: 0;
  top: 0;
  /* height: 18px;
  font: normal normal medium 18px/24px Noto Sans CJK JP; */
}
.probability-label {
  font: normal normal 600 18px/20px Noto Sans;
  margin-left: 3px;
  color: white;
  opacity: 1;
  text-align: left;
}
.probability-value {
  font: normal normal 600 18px/20px Noto Sans;
  margin-left: 3px;
  color: white;
  opacity: 1;
}
.probability-range {
  display: block;
  width: 100%;
  /*width: 375px;*/
  /* margin-right: 100px;
  margin-top: 2rem; */
}
.payment-level-icon {
  margin-right: 10px;
  font: normal normal 600 18px/20px Noto Sans;
  letter-spacing: 0px;
  color: #a9a9a9;
  opacity: 1;
}
.payment-level-label {
  font: normal normal 600 14px/16px Noto Sans;
  margin-right: 20px;
  letter-spacing: 0px;
  color: #a9a9a9;
  opacity: 1;
}
.pattern-select-image-area {
  float: left;
}
.pattern-area {
  background: #404040 0% 0% no-repeat padding-box;
  border: 2px solid #191919;
  border-radius: 10px;
  float: left;
  width: calc(50% - 20px);
  margin: 10px;
  padding-bottom: 30px;
}
.pattern-image-summary {
  float: left;
  margin: 5px;
  border: 1px solid #c7c7c7;
  opacity: 1;
  width: 59px;
  height: 59px;
}
.pattern-image {
  position: relative;
  border: 1px solid #c7c7c7;
  left: 100px;
  width: 59px;
  height: 59px;
}
.layer-summary-text-detail {
  text-align: left;
  padding-top: 3px;
  margin-right: 8px;
  font: normal normal 600 16px/18px Noto Sans;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}
li {
  background: #101010 0% 0% no-repeat padding-box;
  border: 2px solid #191919;
  border-radius: 10px;
  opacity: 1;
}

.delete-button {
  width: 25px;
  height: 25px;
  margin-left: 5px;
  color: #ffffff;
  cursor: pointer;
}

.select-page {
  left: 600px;
}
.swiper-container {
  height: 200px;
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  text-align: left;
  align-content: left;
  align-items: left;
}
.swiper-slide {
  margin-right: 5px;
  text-align: left;
  font-size: 38px;
  font-weight: 700;
  background: #1f1f1f 0% 0% no-repeat padding-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: inline-block;
  -webkit-box-pack: left;
  -ms-flex-pack: left;
  justify-content: left;
  -webkit-box-align: left;
  -ms-flex-align: left;
  align-items: left;
  /* border-left: 1px solid #fff; */
}
.opensea-upload-button {
  /*
  position: relative;
  top: -860px;
  left: 700px;
  width: 220px;
  height: 32px;*/
  background: #147bfc 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.save-button {
  /*
  position: relative;
  top: -860px;
  left: 700px;
  width: 140px;
  height: 32px;*/
  background: #147bfc 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}
.enter {
  border: 10px dotted powderblue;
}

.preview-area {
  margin-top: 2rem;
}
.preview-image {
  width: 100%;
  height: auto;
  margin: 10px 5px;
  /*  width: 140px;
  height: 140px;
  margin: 10px;
*/
}

.project-summary-area {
  padding: 2rem;
}
.contact-support-group {
  margin-top: -25px;
  width: 80%;
}
.contact-button {
  background: transparent linear-gradient(247deg, #6b3dfb 0%, #147bfc 100%) 0%
    0% no-repeat padding-box;
  border-radius: 25px 0px 0px 25px;
  opacity: 1;
  border: none;
}
.support-button {
  background: #583de3 0% 0% no-repeat padding-box;
  border-radius: 0px 25px 25px 0px;
  opacity: 1;
  border: none;
}
.preview-buttn {
  width: 100%;
  /*width: 159px;*/
  height: 47px;
  background: #147bfc 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  margin-top: 50px;
}
.image-cancreate-label {
  /* width: 41px;
height: 36px; */
  text-align: center;
  /* font: normal normal medium 36px/43px Noto Sans CJK JP; */
  font-size: 43px;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
.image-cancreate {
  /*  width: 160px;*/
  width: 100%;
  height: 60px;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  opacity: 1;
}
.layer-summary {
  width: 100%;
  /*width: 400px;*/
  height: 455px;
  background: #101010 0% 0% no-repeat padding-box;
  border: 2px solid #191919;
  border-radius: 10px;
  opacity: 1;
  margin-top: 1rem;
  margin-right: 20px;
}
.layer-add-button {
  width: 100%;
  /*width: 400px;*/
  height: 50px;
  background: #404040 0% 0% no-repeat padding-box;
  border: 2px solid #191919;
  border-radius: 10px;
  opacity: 1;
  /*margin-right: 20px;*/
}
.editor-area-main.row {
  margin: 0 auto;
}
.control-range {
  display: block;
  width: 100%;
  /*width: 375px;*/
  margin-right: 100px;
  margin-top: 2rem;
}
.pattern-input {
  position: relative;
  top: 33px;
  /* left: 120px; */
  width: 340px;
  height: 38px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  opacity: 1;
  margin-left: 30px;
  margin-bottom: 30px;
}
.pattern-summary-name {
  /* width: 360px; */
  height: 38px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e0e0e0;
  opacity: 1;
}
.pattern-require-label {
  bottom: -12px;
  color: #ebff00;
  float: right;
  font-size: 12px;
  padding: 2px 3px;
  position: relative;
  border: 1px solid #ebff00;
  border-radius: 2px;
  right: 10px;
  text-align: center;
}
.pattern-label {
  position: relative;
  top: 33px;
  left: 20px;
  width: 150px;
  height: 24px;
  text-align: left;
  font: normal normal medium 16px/24px Noto Sans CJK JP;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  float: left;
}
.pattern-label-1 {
  position: relative;
  top: 33px;
  left: 20px;
  width: 100%;
  height: 24px;
  text-align: left;
  font: normal normal medium 16px/24px Noto Sans CJK JP;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  /*  float: left;*/
}
.pattern-title {
  margin: 5px;
  text-align: left;
  font: normal normal medium 16px/24px Noto Sans CJK JP;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
.pattern-name {
  float: left;
}
.control-input {
  /*width: 390px;*/
  height: 38px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e0e0e0;
  opacity: 1;
}
.control-label-1 {
  /* width: 128px; */
  height: 16px;
  text-align: left;
  font: normal normal medium 16px/24px Noto Sans CJK JP;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
.control-label-2 {
  /* width: 98px; */
  height: 18px;
  text-align: left;
  margin-top: 2rem;
  font: normal normal 600 13px/18px Noto Sans;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
.control-label-3 {
  width: 100%;
  height: 33px;
  text-align: right;
  margin-left: 0;
  font: normal normal 600 24px/33px Noto Sans;
  letter-spacing: 0px;
  color: #147bfc;
  opacity: 1;
}
.text-left {
  text-align: left;
  /* margin-left: 3rem; */
  margin-top: 3rem;
}
.text-center {
  width: 100%;
  text-align: center;
}
.pattern-button {
  text-align: left;
  margin-left: 30px;
}

.label-1 {
  font: normal normal 600 16px/22px Noto Sans;
  letter-spacing: 0px;
  color: #fcfcfc;
  opacity: 1;
  margin-top: 2rem;
}
.label-2 {
  font: normal normal 600 12px/17px Noto Sans;
  letter-spacing: 0px;
  color: #a5a5a5;
  opacity: 1;
  /* margin-top: 2rem; */
}
.editor-area-1 {
  margin: 1rem 4.2% 0;
  /* width: 1260px; */
  width: 91.6%;
  /*  height: 500px;*/
  background: #1f1f1f 0% 0% no-repeat padding-box;
  box-shadow: inset 10px 13px 10px #00000080;
  border: 1px solid #363636;
  border-radius: 10px;
  opacity: 1;
  padding: 0 15px 10px;
}
.editor-tabs {
  background: #1f1f1f 0% 0% no-repeat padding-box;
  height: 840px;
  margin-top: 1rem;
}
.card {
  background: #454545 0% 0% no-repeat padding-box;
}
.editor-upload-label {
  margin-top: 3rem;
  color: #2d2d2e;
  text-align: center;
  font: normal normal 600 11px/15px Noto Sans;
  letter-spacing: 0px;
}
.editor-upload-button {
  margin-top: 3rem;
  width: 175px;
  height: 30px;
  background: #e5e5e5 0% 0% no-repeat padding-box;
  box-shadow: 5px 6px 6px #00000029;
  border: 1px solid #8e8e8e;
  border-radius: 6px;
  opacity: 1;
}
.editor-upload-area {
  /* width: 1170px; */
  width: 100%;
  height: 160px;
  /* margin-left: 3rem; */
  background: #454545 0% 0% no-repeat padding-box;
  border: 1px solid #707070;
  opacity: 1;
}
.image-list {
  display: flex;
  margin-left: 0px;
  gap: 10px;
}
.image-list img {
  width: 140px;
  height: 168px;
  object-fit: cover;
  background: #c9c9c9;
}
.control-area {
  display: flex;
  /*height: 260px;*/
  width: 91.6%;
  margin: 1rem 4.2%;
  background: #363636 0% 0% no-repeat padding-box;
  border-radius: 10px;
  padding: 0 10px 10px;
}
.control-select-area {
  margin-top: 2rem;
  background: #363636 0% 0% no-repeat padding-box;
  padding: 0 5px;
}

.background {
  background: gray;
  margin: 1rem;
}
.inner {
  width: 30%;
  background: red;
  text-align: left;
}

.left .inner {
  margin-right: auto;
}
.center .inner {
  margin-right: auto;
  margin-left: auto;
}
.right .inner {
  margin-left: auto;
}
.category-list img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: aqua;
}
.tab-height {
  height: 43px;
}
.nav-tabs {
  max-height: 200px;
  height: 200px;
}
.nav-tabs > li:nth-child(1) > a {
  background-color: #2e2e2e;
  color: #ffffff;
}
.nav-tabs > li:nth-child(2) > a {
  background-color: #2e2e2e;
  color: #ffffff;
}
.nav-tabs > li:nth-child(3) > a {
  background-color: #2e2e2e;
  color: #ffffff;
}
.active-tab {
  background: #1f1f1f;
  color: #ffffff;
}
.editor-download-button {
  top: 393px;
  left: 667px;
  width: 175px;
  height: 30px;
  background: #e5e5e5 0% 0% no-repeat padding-box;
  box-shadow: 5px 6px 6px #00000029;
  border: 1px solid #8e8e8e;
  border-radius: 6px;
  opacity: 1;
}
.editor-download-label-2 {
  top: 350px;
  left: 436px;
  width: 588px;
  height: 17px;
  text-align: center;
  font: normal normal 600 12px/17px Noto Sans;
  letter-spacing: 0px;
  color: #a5a5a5;
  opacity: 1;
}
.editor-card {
  position: relative;
  /* top: 210px; */
  left: 30px;
  width: 1260px;
  height: 500px;
  background: #1f1f1f 0% 0% no-repeat padding-box;
  box-shadow: inset 10px 13px 10px #00000080;
  border: 1px solid #363636;
  border-radius: 10px;
  opacity: 1;
}
.editor-label-normal {
  text-align: left;
  font: normal normal normal 18px/24px Noto Sans CJK JP;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
.editor-layer-label {
  position: relative;
  /* top: 253px;
  left: 150px; */
  width: 189px;
  height: 18px;
  text-align: left;
  font: normal normal normal 18px/24px Noto Sans CJK JP;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
.editor-download-area {
  position: relative;
  top: 291px;
  left: 145px;
  width: 1170px;
  height: 160px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #707070;
  opacity: 0.05;
}
.editor-download-label-1 {
  position: relative;
  top: 321px;
  left: 418px;
  width: 624px;
  height: 16px;
  text-align: center;
  font: normal normal 600 16px/22px Noto Sans;
  letter-spacing: 0px;
  color: #fcfcfc;
  opacity: 1;
}
.bl_head_btns {
  position: absolute;
  right: 25px;
  top: 100px;
  z-index: 999 !important;
}
.container-fluid {
  background: #3e3e3e;
}
</style>



// WEBPACK FOOTER //
// src/components/Editor.vue